<template>
  <div id="pageRoot">
    <img
      id="title"
      class="pageElement"
      src="/pages/img/sordoglo/svgGlo7Title.svg"
    />

    <span class="normalTheme pageInstruction" style="left: 87px; top: 155px">
      <p>Completa los nombres con la letra inicial.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 87px; top: 205px">
      <p>Copia los nombres abajo.</p>
    </span>

    <p id="textexample01" class="textBase questionDefault">ATO</p>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      defaultText="P"
      number="100"
      id="inputField01Disabled"
      disabled
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      defaultText="PATO"
      number="101"
      id="inputField02Disabled"
      disabled
    />

    <p id="textexample02" class="textBase questionDefault">OSCA</p>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField02"
      class="pageElement"
    />

    <img
      id="letters"
      class="pageElement"
      src="/pages/img/sordoglo/svgGlo7Letters.svg"
    />
    <img
      id="duck"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo7Duck.svg"
    />
    <img
      id="fly"
      class="pageElement basicItem01"
      src="/pages/img/sordoglo/svgGlo7Fly.svg"
    />
  </div>
</template>
<style scoped>
#title {
  position: absolute;
  left: 82px;
  top: 67px;
}
#inputField01 {
  position: absolute;
  width: 45px;
  left: 300px;
  top: 590px;
}
#inputField02 {
  position: absolute;
  left: 160px;
  top: 660px;
}
#instruct {
  position: absolute;
  left: 87.29px;
  top: 145px;
}
#textexample01 {
  position: absolute;
  left: 367px;
  top: 394px;
  font-size: 30px;
}
#textexample02 {
  position: absolute;
  left: 367px;
  top: 612px;
  font-size: 30px;
}
#inputField01Disabled {
  position: absolute;
  width: 45px;
  left: 300px;
  top: 380px;
}
#inputField02Disabled {
  position: absolute;
  left: 160px;
  top: 460px;
}

#letters {
  position: absolute;
  left: 114px;
  top: 267px;
}
#example {
  position: absolute;
  left: 170px;
  top: 374px;
}
#duck {
  position: absolute;
  left: 649px;
  top: 383px;
}
#fly {
  position: absolute;
  left: 671px;
  top: 608px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 15.mp4", "glo/Video 16.mp4"],
    };
  },
};
</script>